/** Strip leading/trailing slashes so API slug paths never include empty segments. */
export const normalizePatientRoomSlug = (slug: string): string =>
  slug.replace(/^\/+|\/+$/g, '');
